import MuiSlider from '@mui/material/Slider';
import { styled } from '@cp/ds/src/theme/styled';

export const Slider = styled(MuiSlider, {
  name: 'RangeInput',
  slot: 'Root',
})(({ theme }) => {
  return {
    '&.MuiSlider-root': {
      color: theme.palette['brand pink'],
      height: 1,
      width: '100%',
      padding: 0,
      bottom: 0,
    },
    '& .MuiSlider-thumb': {
      height: 20,
      width: 20,
      backgroundColor: theme.palette['brand pink'],
      transition: 'background .3s ease-out',
      '& .Mui-disabled': {
        height: 20,
        width: 20,
        backgroundColor: theme.palette['gray light'],
        marginTop: -10,
        marginLeft: -10,
      },
    },
    '& .MuiSlider-track': {
      height: 1,
      borderWidth: 0,
      backgroundColor: theme.palette['gray'],
    },
    '& .MuiSlider-rail': {
      height: 1,
      opacity: 1,
      backgroundColor: theme.palette['gray'],
    },
    '& .MuiSlider-mark': {
      backgroundColor: theme.palette.white,
      height: 2,
      width: 2,
      borderRadius: 'unset',
    },
    '& .MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: theme.palette.white,
    },
  };
}) as unknown as typeof MuiSlider;
